var map = {
	"./caltech.png": 557,
	"./caltech@2x.png": 558,
	"./campridge.png": 559,
	"./campridge@2x.png": 560,
	"./harvard.png": 561,
	"./harvard@2x.png": 562,
	"./mit.png": 563,
	"./mit@2x.png": 564,
	"./oxford.png": 565,
	"./oxford@2x.png": 566,
	"./stanford.png": 567,
	"./stanford@2x.png": 568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;